import React from 'react';
import { useLang } from '../../../util/lang';
import { FormControl, InputLabel, MenuItem, Select } from '@material-ui/core';

// 渲染后牙垂直距离选择框。
const VerticalDimensionPosteriorSelect = ({ value, name = '',errorPointShow = true, options = [], onChange, label = '' ,upperAndLowerInput='Please Select'}) => {
    const getLang = useLang('NewPatient');

    if (!options || !options.length) return null;
    return (
        <div id={`Q.${name}`}>
            <div style={{ marginLeft: 50, display: 'flex', alignItems: 'center' }}>
                <h4>{label}</h4>
                <FormControl style={{ minWidth: Math.max(140, label.length * 9), marginLeft: 30 }}>
                    {
                       value && <InputLabel>{label}</InputLabel>
                    }
                    <Select value={value} onChange={onChange} 
                        renderValue={(value) => {
                            if (value === '') {
                                return <em>{upperAndLowerInput}</em>;
                            }
                            return value
                        }} 
                        id={'select-' + name} name={name} displayEmpty placeholder={upperAndLowerInput}>
                        <MenuItem value="" disabled>
                            {upperAndLowerInput}
                        </MenuItem>
                        {options.map((opt) => (
                            <MenuItem key={`${opt.value}-${label}`} value={opt.value} disabled={opt?.disabled}>
                                {opt.label}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
                {errorPointShow && (
                    <span style={{ color: 'red' ,marginLeft: '5px'}}>
                        *
                    </span>
                )}
            </div>
        </div>
    );
};

export default VerticalDimensionPosteriorSelect;
